import React, { useContext } from 'react'
import { Button, Spacer, TabMenu, TabMenuButton, View } from 'oio-react'
import { Link, Redirect, Route, Switch, useParams, useRouteMatch } from 'react-router-dom'
import { settingsContentUrl } from 'config/constants/urls'
import ProtoHeadingBlock from 'src/components/Settings/ProtoHeadingBlock'
import ProtoReturnBar from 'src/components/Settings/ProtoReturnBar'
import { useOrganization } from 'src/graphql/hooks'
import ThemeContext from 'src/libraries/contexts/Theme'
import InitiativeTypeAbout from './About'
import InitiativeTypeListing from './Listing'

const SettingsContentInitiativeType = () => {
   const { initiativeTypeId } = useParams()
   const match = useRouteMatch()
   const theme = useContext(ThemeContext)

   const { organization } = useOrganization()
   const initiativeType = organization.initiativeTypes.find(t => t.id === initiativeTypeId)
   const contentInitiativeTypeUrl = `${settingsContentUrl}/initiativeType/${initiativeTypeId}`

   return (
      <View>
         <ProtoReturnBar
            display="block[a-d] none[e-f]"
            returnLinkName="Content & Pages"
            returnLinkTo={settingsContentUrl}
         />
         <View
            display="flex"
            justifyContent="center">
            <View
               maxWidth="100%[a-c] 600px[d-f]"
               padding="40px 20px">
               <View
                  width="100%"
                  display="flex"
                  flexFlow="column[a-c] row[d-f]">
                  <View paddingRight="30px">
                     <ProtoHeadingBlock
                        title={initiativeType.namePlural}
                        description={`This is a list of all the ${initiativeType.namePlural} for your Community Site. You can also further customize this ${initiativeType.namePlural} through the "About this Content Type" tab.`}
                     />
                  </View>
                  <View flex="0 0 auto" paddingTop="30px">
                     <Link to={`${contentInitiativeTypeUrl}/active/create`}>
                        <Button
                           width="120px"
                           name="Create"
                           color={theme.protoSettingsHighlightBackgroundColor}
                           textColor={theme.protoSettingsHighlightForegroundColor}
                           textWeight="medium"
                           size="md"
                           textSize="0.9"
                           padding="25px"
                        />
                     </Link>
                  </View>
               </View>
               <Spacer size="3" />
               <TabMenu
                  backgroundColor="#F7F7F4"
                  buttonPaddingHorizontal="0px"
                  buttonSpacing="24px">
                  <TabMenuButton
                     name="About this Content Type"
                     linkTo={`${contentInitiativeTypeUrl}/about`}
                  />
                  <TabMenuButton
                     name="Active"
                     linkTo={`${contentInitiativeTypeUrl}/active`}
                  />
                  <TabMenuButton
                     name="Archived"
                     linkTo={`${contentInitiativeTypeUrl}/archived`}
                  />
               </TabMenu>
               <Switch>
                  <Redirect
                     exact
                     from={match.path}
                     to={`${match.path}/active`}
                  />
                  <Route
                     path={`${match.path}/:initiativeStatus(active|archived)`}
                     component={InitiativeTypeListing}
                  />
                  <Route
                     path={`${match.path}/about`}
                     component={InitiativeTypeAbout}
                  />
               </Switch>
            </View>
         </View>
      </View>
   )
}

export default SettingsContentInitiativeType
